import { motion } from 'framer-motion';
import Reveal from '@/components/common/Reveal';
import { services } from '@/data/projects';

export const ServicesSection = () => (
  <section id="services" className="py-24 md:py-32 bg-secondary/50 border-y border-border">
    <div className="mx-auto container-editorial">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14">
        <Reveal className="lg:col-span-7">
          <div className="label-eyebrow mb-4">Chapter — Services</div>
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-balance">
            Six things we do <span className="italic-serif text-sienna">unreasonably well.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5 lg:pt-6">
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            We don't sell packages. Every engagement is scoped from a written
            brief, priced honestly, and shipped by the same two people who took
            the first call.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {services.map((s, i) => (
          <motion.article
            key={s.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ delay: i * 0.08, duration: 0.7 }}
            className="card-editorial p-7 md:p-9 flex flex-col min-h-[280px] group"
          >
            <div className="flex items-start justify-between mb-8">
              <span className="font-mono text-xs text-muted-foreground rule-numeric">— {s.n}</span>
              <span className="w-2 h-2 rounded-full bg-sienna/30 group-hover:bg-sienna transition-colors" />
            </div>
            <h3 className="font-serif text-2xl md:text-3xl leading-tight tracking-tight mb-3">
              {s.title}
            </h3>
            <p className="text-sm md:text-base text-muted-foreground leading-relaxed mb-6">
              {s.lede}
            </p>
            <ul className="mt-auto space-y-1.5">
              {s.bullets.map(b => (
                <li key={b} className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-foreground/70">
                  <span className="w-1 h-1 rounded-full bg-foreground/40" /> {b}
                </li>
              ))}
            </ul>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
